import './Expertise.css';
import React from 'react';
import Projects from '../Projects/Projects';

const iconData = [
      {
            img: 'https://i.ibb.co/31Px2s9/file-type-tailwind-icon-130128.png'
      },
      {
            img: 'https://i.ibb.co/CQj2W46/google-firebase-icon-icons-com-61475.png'
      },
      {
            img: 'https://i.ibb.co/DkbTPhk/file-type-gatsby-icon-130583.png'
      },
      {
            img: 'https://i.ibb.co/QDSwLwC/nextjs-icon-132160.png'
      },
      {
            img: 'https://i.ibb.co/Khnb4zD/bootstrap-plain-wordmark-logo-icon-146620.png'
      },
      {
            img: 'https://i.ibb.co/fdY0W7r/nodejs.png'
      },
      {
            img: 'https://i.ibb.co/5vnYZqb/physics.png'
      },
      {
            img: 'https://i.ibb.co/6FJzwbf/javascript.png'
      },
      {
            img: 'https://i.ibb.co/qs4VJyv/html-5.png'
      },
      {
            img: 'https://i.ibb.co/BT2zCzT/mongodb-plain-wordmark-logo-icon-146423.png'
      },
      {
            img: 'https://i.ibb.co/b6YDJr3/css.png'
      }
]

const Expertise = () => {

      return (
            <section style={{}} className='expertise-container mt-5'>
                  <div className="container d-flex">
                        <div data-aos="fade-up-right" className="row">
                              <div className="col-md-12">
                                    <h1 className='brand brand-link link'>What I'm Into?</h1>
                                    <p style={{ color: '#6c757d' }}>The primary area of my interest is undoubtedly front-end. Experienced with various ways to deal with the advancement of dynamic web projects. Knowledgeable in various programming dialects and libraries including HTML5, CSS3, JavaScript, ReactJS, NodeJS, MongoDB, MySQL, PHP, Java, Python and so on.
                                    <br />
                                          <br />
                                     Solid foundation in Project Management and Customer Relations. Involvement with software development process like Agile, Scrum and MVC (Model-View-Controller) configuration design. I'm keen on creating easy to understand web applications in MERN Stack.
                                     <br />
                                     I love to work with new advances and playing with various stacks.
                                    <br />
                                          <br />
                                    More about my experience and work you'll find on <a className='text-decoration-none brand brand-link' href="/expertise">Skills</a> and <a className='text-decoration-none brand brand-link' href="/about">About</a>.
                              </p>
                              </div>

                              <div className="col-md-12">
                                    

                              </div>
                              {iconData.map(ic =>
                                    <img style={{ width: '50px' }} className='img-fluid mt-3' src={ic.img} alt="" srcset="" />
                              )}
                        </div>

                  </div>

                  <Projects />

            </section>
      );
};

export default Expertise;